module.exports = __webpack_public_path__ + "static/media/meditate3.f6b411bb.jpg";